import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

const useMarketSectors = ({
  marketSectorIds,
}: {
  marketSectorIds?: string[]
} = {}) => {
  const trpc = useTRPC()
  return useQuery(
    trpc.marketSectors.getMarketSectors.queryOptions({
      market_sector_ids: marketSectorIds,
    })
  )
}

export default useMarketSectors
